import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox.css';

const initFancybox = () => {
  Fancybox.bind('[data-fancybox]', {
    Toolbar: {
      display: [
        'close',
      ],
    },
    Image: {
      zoom: false,
    },
    animated: false,
    preload: 0,
    template: {
      buttons: '',
    },
  });
};
// eslint-disable-next-line import/prefer-default-export
export { initFancybox };
